import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const NewsArticleSchema = ({ headline, mainEntityId, imageUrl, datePublished, dateModified, schemaDescription }) => {
  const schemaData = {
    "@context": "http://schema.org",
    "@type": "NewsArticle",
    "headline": headline,
    "image": {
      "@type": "ImageObject",
      "url": imageUrl,
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": mainEntityId,
    },
    "description": schemaDescription,
    "datePublished": datePublished,
    "dateModified": dateModified,
    "author": {
      "@type": "Organization",
      "name": "Jameel Health",
    },
    "publisher": {
      "@type": "Organization",
      "name": "Jameel Health",
      "logo": {
        "@type": "ImageObject",
        "url": "https://jameelhealth.com/static/logo-white-982d4aa88e6404542625b282cca5bd58.png",
      },
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaData)}
      </script>
    </Helmet>
  );
};

NewsArticleSchema.propTypes = {
  headline: PropTypes.string.isRequired,
  mainEntityId: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  datePublished: PropTypes.string.isRequired,
  dateModified: PropTypes.string,
};

NewsArticleSchema.defaultProps = {
  dateModified: '',
};

export default NewsArticleSchema;
